import FaqSection from "../components/HTML/ITRFile/FaqSection";
import ITRFileHeaderSection from "../components/HTML/ITRFile/ITRFileHeaderSection";
import Fullpage from "../components/Layout/Fullpage";
import { Helmet } from "react-helmet-async";
import React, { useEffect, useState } from "react";
import ITRVideoCardSection from "../components/HTML/ITRFile/ITRVideoCardSection";
import ClientTestimonial from "../components/HTML/ClientTestimonial";
import ITRHowToFile from "../components/ITRHowToFile";
import Incometaxfiling from "../components/Pages/Calendly/Incometaxfiling";
import HideHeader from "../components/HideHeader";
import Cookies from 'js-cookie'
import { trackWebEngageEvent } from "../Utils/Webengageevent/webengageUtils";
function ITRFile() {
  const [show, SetShow] = useState(false);
  const [utmSource, setUtmSource] = useState(26);
  const [tagval, setTagval] = useState("");
  const [pageurl, setPageurl] = useState();
  useEffect(() => {

    trackWebEngageEvent("page viewed", {
      page_url: window.location.href ?? ''
    });

    function extractParametersFromURL() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const utmSourceParam = urlSearchParams.get("utm_source");
      const tagvalParam = urlSearchParams.get("tags");
      const rm_id = urlSearchParams.get("rm_id");

      if (utmSourceParam || tagvalParam) {
        setUtmSource(utmSourceParam);
        setTagval(tagvalParam);
        setPageurl(window.location.pathname);
        const cookieOptions = { expires: 0.0208 };
        // const cookieOptions = { expires: 0.00139 };
        Cookies.set("utm_source", utmSourceParam || "", cookieOptions);
        Cookies.set("tagval", tagvalParam || "", cookieOptions);
        Cookies.set("rm_id", rm_id || "", cookieOptions);
        Cookies.set("pageurl", window.location.pathname, cookieOptions);
      } else {
        const storedUtmSource = Cookies.get("utm_source") || null;
        const storedTagval = Cookies.get("tagval") || null;
        const storedPageurl = Cookies.get("pageurl") || null;
        const storedRmid = Cookies.get("rm_id") || null;

        setUtmSource(storedUtmSource);
        setTagval(storedTagval);
        setPageurl(storedPageurl);
      }
    }

    extractParametersFromURL();
    window.addEventListener("popstate", extractParametersFromURL);

    return () => {
      window.removeEventListener("popstate", extractParametersFromURL);
    };
  }, [window.location.search]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!Cookies.get("utm_source") && !Cookies.get("tagval") && !Cookies.get("pageurl") && !Cookies.get("rm_id")) {
        setUtmSource(utmSource);
        setTagval(null);
        setPageurl(null);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);
  console.log("utmSource:", utmSource, "tagval:", tagval, "pageurl:", pageurl);

  return (
    <Fullpage>
      {window.location.href.includes("itr_2024") && <HideHeader />}
       <Helmet>
        <meta name="keywords" content="e filing income tax login, income tax login, itr login, itr filing, itr e-filing, income tax e filing, income tax return filing, itr efiling, income tax filing, income tax e filing portal, itr filing online" />
       </Helmet>

      {window.location.href.includes("itr_2024") && <HideHeader />}
      <div style={{ backgroundColor: "white" }}>
      <ITRFileHeaderSection />
        {/* <ITRCardSection /> */}
        {/* <ITRHowToFile /> */}
        {/* <div id="ITRBook">
         <Incometaxfiling eventCode={'itr_filing_2025'} serviceName="Income Tax Filing" eventUrl="https://calendly.com/d/223-wk6-b79/itr-15-mins-introduction-with-tax-expert?hide_event_type_details=1&hide_gdpr_banner=1&month=2023-07"/>
        </div> */}
        <div id="ITRVideo">
          <ITRVideoCardSection />
        </div>
        <ITRHowToFile />
        {/* <ITRFile /> */}
        <ClientTestimonial />
        <FaqSection />
      </div>
    </Fullpage>
  );
}

export default ITRFile;